// ═══════════════════════════════════════════════════════════════════
//  modules/documents/MarquesModule.js
//  MarquesModule
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { CrudModal } from "../../composants/CrudModal";
import { DataTable } from "../../composants/DataTable";
import { btnBack, btnPrimary } from "../../composants/styles";
import { useCrud } from "../../socle/hooks";
import { THEME } from "../../socle/theme";

// ═══════════════ 4) MARQUES, DOMAINES & PI ═══════════════
export function MarquesModule({ token, onBack }) {
  const [tab,setTab]=useState("domaines");
  const dom=useCrud(token,"/api/documents/domaines");
  const mar=useCrud(token,"/api/documents/marques");
  const [editD,setEditD]=useState(undefined);
  const [editM,setEditM]=useState(undefined);

  const DOM_STATUTS={actif:"Actif",litige:"Litige",expire:"Expiré",a_renouveler:"À renouveler"};
  const today=new Date(); const soon=new Date(); soon.setDate(today.getDate()+45);
  const expWarn=(d)=>{ if(!d)return null; const dt=new Date(d); if(dt<today)return THEME.red; if(dt<soon)return THEME.amber; return null; };

  const domFields=[
    {key:"nom",label:"Domaine",full:true,placeholder:"orialis.fr"},
    {key:"registrar",label:"Registrar",placeholder:"OVH"},
    {key:"date_expiration",label:"Expiration",type:"date"},
    {key:"renouvellement_auto",label:"Renouvellement auto",type:"checkbox"},
    {key:"statut",label:"Statut",type:"select",options:Object.entries(DOM_STATUTS).map(([v,l])=>({value:v,label:l}))},
    {key:"note",label:"Note",full:true,type:"textarea"},
  ];
  const domCols=[
    {key:"nom",label:"Domaine",width:"1fr",render:(r)=><span style={{fontWeight:600}}>{r.nom}</span>},
    {key:"registrar",label:"Registrar",width:"110px"},
    {key:"date_expiration",label:"Expiration",width:"130px",render:(r)=>{const c=expWarn(r.date_expiration); return <span style={{color:c||THEME.text}}>{r.date_expiration?r.date_expiration.slice(0,10):"—"}{c&&" ⚠"}</span>;}},
    {key:"renouvellement_auto",label:"Auto",width:"70px",render:(r)=>r.renouvellement_auto?"✓":"—"},
    {key:"statut",label:"Statut",width:"110px",render:(r)=><span style={{color:r.statut==="litige"?THEME.red:r.statut==="actif"?THEME.emerald:THEME.amber}}>{DOM_STATUTS[r.statut]||r.statut}</span>},
  ];

  const MAR_TYPES={marque:"Marque",logo:"Logo",autre:"Autre"};
  const marFields=[
    {key:"nom",label:"Nom",full:true,placeholder:"Boxoria"},
    {key:"type",label:"Type",type:"select",options:Object.entries(MAR_TYPES).map(([v,l])=>({value:v,label:l}))},
    {key:"depot_inpi_statut",label:"Dépôt INPI",placeholder:"Non déposé / en cours…"},
    {key:"statut",label:"Statut"},
    {key:"historique_litige",label:"Historique litige (SYRELI…)",full:true,type:"textarea"},
    {key:"note",label:"Note",full:true,type:"textarea"},
  ];
  const marCols=[
    {key:"nom",label:"Nom",width:"1fr",render:(r)=><span style={{fontWeight:600}}>{r.nom}</span>},
    {key:"type",label:"Type",width:"100px",render:(r)=>MAR_TYPES[r.type]||r.type},
    {key:"depot_inpi_statut",label:"Dépôt INPI",width:"1fr",render:(r)=><span style={{color:THEME.textMuted}}>{r.depot_inpi_statut||"—"}</span>},
    {key:"statut",label:"Statut",width:"120px"},
  ];

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onBack} style={btnBack}>← Documents</button>
        <h2 style={{color:THEME.text,fontSize:18,fontWeight:800,margin:0}}>🏷️ Marques, domaines & PI</h2>
        <button onClick={()=>tab==="domaines"?setEditD(null):setEditM(null)} style={{marginLeft:"auto",...btnPrimary}}>{tab==="domaines"?"+ Domaine":"+ Marque / logo"}</button>
      </div>
      <div style={{display:"flex",gap:6}}>
        {[["domaines","🌐 Domaines"],["marques","®️ Marques & logos"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setTab(id)} style={{background:tab===id?THEME.accentDim:"transparent",border:`1px solid ${tab===id?THEME.accent:THEME.border}`,color:tab===id?THEME.accent:THEME.textMuted,borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:13,fontWeight:tab===id?700:400}}>{lbl}</button>
        ))}
      </div>

      {tab==="domaines" ? (
        dom.loading ? <div style={{color:THEME.textMuted,padding:20}}>Chargement…</div> :
          <DataTable columns={domCols} rows={dom.items} onEdit={setEditD} onDelete={(id)=>{if(window.confirm("Supprimer ce domaine ?"))dom.remove(id);}} empty="Aucun domaine enregistré." />
      ) : (
        mar.loading ? <div style={{color:THEME.textMuted,padding:20}}>Chargement…</div> :
          <DataTable columns={marCols} rows={mar.items} onEdit={setEditM} onDelete={(id)=>{if(window.confirm("Supprimer cette entrée ?"))mar.remove(id);}} empty="Aucune marque / logo enregistré." />
      )}

      {editD!==undefined && <CrudModal title={editD?"Éditer le domaine":"Nouveau domaine"} fields={domFields} initial={editD} onClose={()=>setEditD(undefined)} onSave={async(b)=>{ editD?await dom.update(editD.id,b):await dom.create(b); setEditD(undefined); }} />}
      {editM!==undefined && <CrudModal title={editM?"Éditer la marque":"Nouvelle marque / logo"} fields={marFields} initial={editM} onClose={()=>setEditM(undefined)} onSave={async(b)=>{ editM?await mar.update(editM.id,b):await mar.create(b); setEditM(undefined); }} />}
    </div>
  );
}
